<template>
  <v-app style="height: 100%">
    <v-main>
      <title-page
        :title="'باربری‌های همکار'"
        :sheetStyle="['transparent', '-mt-1']"
        backLink="/Panel/LoadManagement"
      >
        <template #navbar>
          <v-btn
            block
            large
            class="logistic-color white--text button-medium"
            elevation="0"
          >
            <v-icon class="ml-2">mdi-plus</v-icon>
            افزودن باربری همکار
          </v-btn>
        </template>

        <list-item-card
          deletable
          class="ma-4 mb-0"
          :id="'asdasda'"
          :title="'پیک کویر'"
          :name="'محمد جواد نوروزی'"
          :phone="'09104943429'"
          :address="'تهران، کوی بیمه، کارخانه نوآوری آزادی، پلاک 56 تهران، کوی بیمه، کارخانه نوآوری آزادی، پلاک 56'"
        >
        </list-item-card>

        <br />
        <br />
        <br />
      </title-page>
    </v-main>
  </v-app>
</template>

<script>
import TitlePage from "../components/Layouts/TitlePage.vue";
import ListItemCard from "../components/ListItemCard.vue";

export default {
  name: "CoBarbari",
  components: { TitlePage, ListItemCard },
  data() {
    return {
      coBarbaries: [],
    };
  },
  methods: {
    getCoBarbaries() {
      //
    },
    setCoBarbaries() {
      //
    },
  },
};
</script>

<style scoped></style>
